const convertDateToServerFormat = date => {
  if (!date) return undefined;
  const ye = new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date);
  const mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(date);
  const da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
  return `${ye}-${mo}-${da}`;
};

export default convertDateToServerFormat;
